import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

export default function SetZoomControlPosition() {
  const map = useMap();
  useEffect(() => {
    if (map.zoomControl) map.zoomControl.setPosition('bottomright');
  }, [map]);
  return null;
}
